﻿import { DataRequest } from 'shared/data/datarequest';

export class FieldDataRequest extends DataRequest {
    identifier: string;
    fieldName: string;

    constructor(identifier: string, fieldName: string) {
        super();

        this.$type = 'Web.FieldDataRequest';
        this.identifier = identifier;
        this.fieldName = fieldName;
    }
}